export const ActionTypes = {
    SET_USERS: "SET_USERS",
    ADD_USER: "ADDED_USER",
    UPDATE_USER: "UPDATED_USER",
    DELETE_USER: "DELETED_USER",
    SET_ROLES: "SET_ROLES",
    SET_GROUPS: "SET_GROUPS"
}